// frontend/src/components/auth/LoginForm.js
import React, { useState } from 'react';
import { loginUser } from '../../api/auth';
import { useNavigate } from 'react-router-dom';
import { useChat } from '../../context/ChatContext.js';
import './LoginRegister.css';

export default function LoginForm() {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [message, setMessage] = useState(null);
  const navigate = useNavigate();
  const { updateMemory, updateUser } = useChat();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('🟨 handleSubmit triggered');
  
    try {
      const res = await loginUser(formData);
      console.log('📥 LoginForm received response:', res);
  
      if (!res || typeof res !== 'object') {
        console.error('❌ Login failed: Invalid response object:', res);
        setMessage('Login failed: Server returned unexpected data.');
        return;
      }
  
      const {
        id,
        token,
        shadow_id,
        first_name,
        last_name,
        email,
        access_level,
        trial_start_date,
        trial_expiry_date,
        is_free_override,
      } = res;
  
      if (!id || !token) {
        console.error('🛑 Missing critical fields (id or token) in login response:', res);
        setMessage('Login failed: Incomplete response.');
        return;
      }
  
      const user = {
        id,
        shadow_id,  // ✅ now preserved as-is
        first_name,
        last_name,
        email,
        access_level,
        trial_start_date,
        trial_expiry_date,
        is_free_override,
      };
      
      console.log('✅ Final user object:', user);
      console.log('🔐 Token:', token);
      
      // 🔐 Save user + token to localStorage
      const finalUser = { ...user, shadowId: res.shadow_id, token };
      localStorage.setItem('daisy-user', JSON.stringify(finalUser));
      
  
      // 🧠 Update context
      updateUser(finalUser);
      updateMemory('userId', id);
      updateMemory('userName', first_name || 'Friend');
  
      // 🔁 Pull session memory context (relationships, books, quotes)
try {
  const sessionRes = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/session/init`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });

  if (!sessionRes.ok) throw new Error(`Session init failed: ${sessionRes.statusText}`);
  const { relationships = [], books = [], quotes = [] } = await sessionRes.json();

  updateMemory('userRelationships', relationships);
  updateMemory('userBooks', books);
  updateMemory('userQuotes', quotes);

  // 🔁 Pull session memory context (relationships, books, quotes)
try {
  const sessionRes = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/session/init`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });

  if (!sessionRes.ok) throw new Error(`Session init failed: ${sessionRes.statusText}`);
  const { relationships = [], books = [], quotes = [] } = await sessionRes.json();

  updateMemory('userRelationships', relationships);
  updateMemory('userBooks', books);
  updateMemory('userQuotes', quotes);

  // ✅ Store relationships in their own localStorage context
  localStorage.setItem('daisy-relationships', JSON.stringify(relationships));

  console.log('✅ Session memory updated:', { relationships, books, quotes });
} catch (err) {
  console.error('⚠️ Failed to fetch session memory:', err.message);
}


  console.log('✅ Session memory updated:', { relationships, books, quotes });
} catch (err) {
  console.error('⚠️ Failed to fetch session memory:', err.message);
}


      // 🌐 Navigate based on access level
      if (access_level === 'expired') {
        navigate('/welcome', {
          state: {
            expired: true,
            user_id: id,
            email,
            first_name,
          },
        });
      } else {
        navigate('/chat');
      }
    } catch (err) {
      console.error('🚨 Login catch block triggered:', err);
      setMessage(err.message || 'Login failed. Please try again.');
    }
  };
  
  return (
    <div className="auth-container">
    <form onSubmit={handleSubmit}>
      <h2>Login</h2>
      <input
        name="email"
        placeholder="Email"
        value={formData.email}
        onChange={handleChange}
        required
      />
      <input
        name="password"
        type="password"
        placeholder="Password"
        value={formData.password}
        onChange={handleChange}
        required
      />
      <button type="submit">Login</button>
      {message && <p>{message}</p>}
    </form>

 {/* 🔗 Support Links for Register + Reset */}
 <div className="auth-links">
      <p>
        Don’t have an account? <a href="/register">Register here</a>
      </p>
      <p>
        Forgot your password? <a href="/reset-password">Reset it</a>
      </p>
    </div>
    
    </div>
  );
}
